"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogService = void 0;
var tslib_1 = require("tslib");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var editor_type_1 = require("@wix/wix-vod-shared/dist/src/common/utils/editor-type");
var CatalogService = /** @class */ (function () {
    function CatalogService(httpClient, baseUrlPath) {
        if (baseUrlPath === void 0) { baseUrlPath = ''; }
        this.httpClient = httpClient;
        this.baseUrlPath = baseUrlPath;
    }
    Object.defineProperty(CatalogService.prototype, "defaultOptions", {
        get: function () {
            return {
                baseURL: this.getBaseUrl(),
                xsrfCookieName: 'non-existing-cookie',
                withCredentials: true,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogService.prototype, "baseOrigin", {
        get: function () {
            return (0, editor_type_1.isEditorX)()
                ? hosts_1.PRODUCTION_HOSTS.catalogEditorX
                : hosts_1.PRODUCTION_HOSTS.catalog;
        },
        enumerable: false,
        configurable: true
    });
    CatalogService.prototype.getBaseUrl = function () {
        return this.baseOrigin + this.baseUrlPath;
    };
    CatalogService.prototype.request = function (requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.request(tslib_1.__assign(tslib_1.__assign({ baseURL: this.getBaseUrl() }, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.post = function (url, data, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.post(this.getBaseUrl() + url, data, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.patch = function (url, data, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.patch(this.getBaseUrl() + url, data, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.put = function (url, data, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.put(this.getBaseUrl() + url, data, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.get = function (url, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.get(this.getBaseUrl() + url, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.delete = function (url, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.delete(this.getBaseUrl() + url, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    return CatalogService;
}());
exports.CatalogService = CatalogService;
//# sourceMappingURL=catalog-service.js.map